import { ClientUsersClient } from '@src/clientUser/manage/ClientUsersClient';
import { useMutation } from '@tanstack/react-query';

export const useConfirmCognitoClientUser = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  const { mutate: confirmCognitoUser, isPending: isConfirming } = useMutation({
    mutationFn: ({
      clientUserId,
      clientId,
    }: {
      clientUserId: string;
      clientId: string;
    }) => ClientUsersClient.confirmCognitoUser(clientUserId, clientId),
    onSuccess,
  });

  return {
    confirmCognitoUser,
    isConfirming,
  };
};
